import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

import ImgA from "../../assets/images/a.jpg";
import ImgB from "../../assets/images/b.jpg";
import ImgL from "../../assets/images/l.jpg";
import Img1 from "../../assets/images/features/img-1.png";
import STWaitlistForm from "../../component/STWaitlistForm";

class Section extends Component {
  constructor() {
    super();
    const experiments = [
      {
        waitlist_version: 1,
        waitlist_name: "doupartners",
        header: "Run Ads for Guaranteed, High-Quaity Feedback.",
        subheader:
          "Get authentic, actionable feedback from 100 viewers who are paid to pay attention - no bots, no skips, just honest insights to boost your ROI.",
        CTA: "I Want To Join The Partner Pilot Program.",
        img: ImgA,
      },
    ];

    // Check if an experiment is already stored in localStorage
    const persistedExperiment = localStorage.getItem("selectedExperiment");
    const selectedExperiment = persistedExperiment
      ? JSON.parse(persistedExperiment)
      : experiments[Math.floor(Math.random() * experiments.length)];

    // Save the selected experiment to localStorage if it wasn't already saved
    if (!persistedExperiment) {
      localStorage.setItem(
        "selectedExperiment",
        JSON.stringify(selectedExperiment)
      );
    }

    this.state = {
      isOpen: false,
      selectedExperiment,
    };

    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  render() {
    const { header, subheader, img } = this.state.selectedExperiment;

    return (
      <React.Fragment>
        <section className="bg-home bg-light" id="home">
          <div className="home-center">
            <div className="home-desc-center">
              <Container>
                <Row className="align-items-center">
                  <Col lg={6}>
                    <div className="home-content">
                      <div className="home-img">
                        <div className="animation-4"></div>
                      </div>
                      <p className="biz-name mt-4 mb-0">
                        Pilot Partners Program
                      </p>
                      <h1 className="home-title mt-4">{header}</h1>
                      <p className="text-muted mt-4 f-20">
                        Get authentic, actionable feedback from 100 viewers who
                        are <em>paid to pay attention</em> - no bots, no skips,
                        just honest insights to boost your ROI.
                      </p>
                      <STWaitlistForm />
                      <p className="text-muted mt-4 f-10 text-center">
                        We'll never share your information with anyone.
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="home-img">
                      <div className="animation-1"></div>
                      <div className="animation-2"></div>
                      <div className="animation-3"></div>
                      <div className="hero">
                        <img
                          src={img}
                          className="img-fluid hero-photo"
                          alt=""
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </section>
        {/* <section className="section bg-light bg-features">
          <Container>
            <Row className="align-items-center">
              <Col lg={5}>
                <div className="mt-4 home-img">
                  <div className="animation-2"></div>
                  <div className="animation-3"></div>
                  <img src={Img1} className="img-fluid" alt="" />
                </div>
              </Col>
              <Col lg={6} className="offset-lg-1">
                <div className="mt-4">
                  <h2>Get authentic insights</h2>
                  <p className="mt-4 text-muted">
                    Your $500 investment buys 100 human insights to refine your
                    ad - cheaper than a failed campaign.
                  </p>

                  <div className="mt-4">
                    <Link to="#" className="btn btn-primary">
                      Get reviews
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section> */}
      </React.Fragment>
    );
  }
}

export default Section;
